.viewProfileDialog {
  height: 100%;
}

.viewProfileDialogBody {
  display: flex;
  flex-direction: column;
  padding-bottom: 2px;
}

.contactAttributes,
.contactAttributesBottom {
  margin-top: 15px;
  margin-inline-start: -4px;
  font-size: 1.08em;
}
.contactAttributes > *,
.contactAttributesBottom > * {
  margin-bottom: 8px;
}
.contactAttributes > * > img,
.contactAttributesBottom > * > img {
  width: 1.15em;
  height: 1.15em;
  margin-inline-start: 0.3em;
  margin-inline-end: 0.3em;
  vertical-align: middle;
}

.contactAttributesBottom {
  padding: 10px 15px;
  margin-top: auto;
}

.verification {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
}

.buttonWrap {
  margin: 10px 0 24px 0;
  margin-inline-start: 30px;
}
.buttonWrap button {
  min-width: 150px;
}

.extendedSeparator {
  margin-inline-start: -30px;
  margin-inline-end: -30px;
  padding: 2px;
}

.mutualChats {
  margin-top: 8px;
}